module.exports = __webpack_public_path__ + "static/fipcbrownleopard3-95421ab94c52ccba06cabdd6cd216d09.jpeg";